:host{width:100%;height:100%;display:flex;flex-direction:column;gap:1px}mat-button-toggle-group{background-color:#fff;width:100%;min-height:var(--ursa--split-view-toolbar-height)}
/*# sourceMappingURL=settings-panel.component.css.map */
